// extracted by mini-css-extract-plugin
export default {"head":"PageHeader_head__JLtDH","spacer":"PageHeader_spacer__oD9Jj","actions":"PageHeader_actions__Z9IOG"};